import * as Public from '@interface/public';
// import * as Page from '@interface/page';

export default {
  ...Public,
  // ...Page
};